import {Label} from '@fluentui/react/lib/Label';
import {FC, useEffect, useState} from 'react';
import styles from './acknowledgementUnit.module.scss';
import {
  DatePicker,
  DayOfWeek,

  Spinner
} from '@fluentui/react';

import {GroupsPicker} from '../../common/PeoplePicker/GroupPicker';
import {DocumentSystem} from '../../../models/DocumentSystem';
import {PeoplePicker} from '../../common/PeoplePicker';
import {Richtext} from '../../common/Richtext';
import {EnhancedDetailsList} from '../../common/EnhancedDetailsList';
import {TheButton} from '../../common/TheButton';
import {mapDocumentToDocumentSystem} from '../../../helpers/documentMapper';
import {MiddleTopBarUnitManage} from '../../common/MiddleTopBarUnitManage';
import {HeadingWithDecoration} from '../../common/HeadingWithDecoration';
import {AcknowledgementsProcess} from '../../../models/AcknowledgementsProcess';
import {ConfirmationModal} from './ConfirmationModal';
import {Helmet} from 'react-helmet';
import {AcknowledgementTemplatePicker} from './AcknowledgementTemplatePicker';
import { useAcknowledgementTemplate } from '../../../hooks/services/useAcknowledgementTemplate';
import { useAcknowledgementUnit } from './useAcknowledgementUnit';

function mapChangedDocumentToDocument(changedItem: DocumentSystem): DocumentSystem {
  return changedItem;
}

function mapChangedProcessToProcess(changedItem: AcknowledgementsProcess): AcknowledgementsProcess {
  return changedItem;
}

export const AcknowledgementUnit: FC<{
  unitId: number;
  unitTitle: string | undefined;
}> = ({unitId, unitTitle}) => {
  
  const {getTemplateById} = useAcknowledgementTemplate();
  const [elementsError, setElementsError] = useState<boolean>(true);
  const [templateTitle, setTemplateTitle] = useState<string | undefined>(undefined);
  const [templateLoading, setIsTemplateLoading] = useState<boolean>(false);

  const {documents,
    setDocuments, 
    onChangeComment, 
    commentValue, 
    commentError, 
    setDeadlineValue, 
    isModalVisible,
    setIsModalVisible,
    deadline, 
    deadlineError, 
    deadlinePastError, 
    setCommentValue, 
    today, 
    errorMsg, 
    processes,
    setProcesses,
    collectGroups,
    openConfirmationModal, 
    openConfirmationTemplateModal,
    collectPersons,
    onConfirmForm,
    selectedPersons,
    selectedGroups,
    columsProcessView,
    getProcessesUsedInUnit,
    getDocumentsUsedInUnit,
    selectedKey,
    documentsTableTouched,
    processTableTouched,
    isLoading,
    peopleError,
    columnsView,
    cancel,
    changedProcesses,
    changedDocuments,
    setIsLoading,
    setSelectedKey,
    isTemplateModalVisible,
    setIsTemplateModalVisible,
    setErrorMsg} = useAcknowledgementUnit();

  useEffect(() => {
    const fetchTemplate = async () => {   
      try {
        setIsTemplateLoading(true);
        const response = await getTemplateById(selectedKey);
        if(selectedKey === -1)
        {
          setErrorMsg({})
        }
        if (response.result) {
          setCommentValue(response.result.reason === null ? undefined : response.result.reason);
          setTemplateTitle(response.result.title === null ? undefined : response.result.title);
          setDocuments(prevDocuments =>
              prevDocuments.map(item => ({
                ...item,
                checkedAcknowledgementItem: response?.result?.documentIds.includes(item.id)
              }))
            );
            setProcesses(prevProcesses =>
                prevProcesses.map(item => ({
                  ...item,
                  checkedAcknowledgementItem: response?.result?.processIds.includes(item.id)
                }))
              );
            

        } else {
          setCommentValue(undefined);
        }
      } catch (error) {
        setCommentValue(undefined);
      }
      setIsTemplateLoading(false);
    };

    fetchTemplate();
  }, [selectedKey, getTemplateById, setCommentValue, setErrorMsg, setDocuments, setProcesses]);

  useEffect(() => {
    if (
      processes.some(item => item.checkedAcknowledgementItem) ||
      documents.some(item => item.checkedAcknowledgementItem)
    ) {
      setElementsError(false);
    } else {
      setElementsError(true);
    }
  }, [processTableTouched, documentsTableTouched, processes, documents]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [documentsResponse, processesResponse] = await Promise.all([
          getDocumentsUsedInUnit(unitId),
          getProcessesUsedInUnit(unitId)
        ]);

        if (documentsResponse?.result) {
          setDocuments(documentsResponse.result.map(doc => mapDocumentToDocumentSystem(doc)));
        }

        if (processesResponse?.result) {
          setProcesses(processesResponse.result);
          console.log('Processes fetched for unit:', processesResponse.result);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [unitId, getDocumentsUsedInUnit, getProcessesUsedInUnit, setDocuments, setProcesses, setIsLoading]);


  return (
    <main className={`${isLoading ? 'isLoading' : ''} noPaddingTop`}>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <MiddleTopBarUnitManage
            notUseHelmet
            unitId={unitId ? unitId : undefined}
            active={'acknowledgements'}
          />
          <HeadingWithDecoration text="Acknowledgement form" />
          {unitTitle && (
            <Helmet>
              <title>IMS {unitTitle} Acknowledgement</title>
            </Helmet>
          )}

          <div className={styles.acknowledgement}>
            <div>

            <AcknowledgementTemplatePicker 
            unitId={unitId} 
            openConfirmationTemplateModal={openConfirmationTemplateModal}
            reason={commentValue || ''}
            isLoading={templateLoading}
            setIsLoading={setIsTemplateLoading}
            templateTitle={templateTitle}
            selectedKey={selectedKey}
            setSelectedKey={setSelectedKey}
            documents={documents.filter(item => item.checkedAcknowledgementItem)}
            processes={processes.filter(item => item.checkedAcknowledgementItem)}
            isTemplateModalVisible={isTemplateModalVisible}
            setIsTemplateModalVisible={setIsTemplateModalVisible}
            />
            </div>
            {peopleError && errorMsg.errorPeopleMsg}
            <div className={styles.acknowledgementPicker}>
              <Label htmlFor={'peoplePicker'}>Choose Recipients - Individual Email Address</Label>
              <PeoplePicker
                key={'peoplePicker'}
                onSelectPerson={value => collectPersons(value)}
                itemLimit={50}
              />

              <Label htmlFor={'groupPicker'}>Choose Recipients - Group Email Addresses</Label>
              <GroupsPicker
                key={'groupPicker'}
                onSelectGroup={value => collectGroups(value)}
                itemLimit={50}
              />
              {deadlineError && errorMsg.errorDateMsg}
              {deadlinePastError && errorMsg.errorDatePastMsg}
              <DatePicker
                label="Choose deadline"
                firstDayOfWeek={DayOfWeek.Monday}
                placeholder="Select a date..."
                ariaLabel="Select a date"
                minDate={today}
                onSelectDate={date => {
                  setDeadlineValue(date);
                }}
              />
              {commentError && errorMsg.errorCommentMsg}
              <div className={styles.comment}>
                <label>Background / Reason (it will be displayed on the Notification)</label>
                {templateLoading ? <Spinner /> : <Richtext value={commentValue} onChange={content => onChangeComment(content)} />}
              </div>
            </div>
            {elementsError && errorMsg.errorElementMsg}
            
             <label className={styles.label}>Choose documents</label>
             {templateLoading ? <Spinner /> : 
            <EnhancedDetailsList<DocumentSystem, DocumentSystem, DocumentSystem>
              columns={columnsView}
              items={documents || []}
              changedItems={changedDocuments}
              mapChangedItemToItem={mapChangedDocumentToDocument}
            />}
            {elementsError && errorMsg.errorElementMsg}
            
            <label className={styles.label}>Choose processes</label>
             {templateLoading ? <Spinner /> : 
            <EnhancedDetailsList<
              AcknowledgementsProcess,
              AcknowledgementsProcess,
              AcknowledgementsProcess
            >
              columns={columsProcessView}
              items={processes || []}
              changedItems={changedProcesses}
              mapChangedItemToItem={mapChangedProcessToProcess}
            />}
            <footer className={styles.acknowledgementBtn}>
              <TheButton onClick={() => cancel(unitId)}>Cancel</TheButton>
              <TheButton primary onClick={() => openConfirmationModal()}>
                Confirm & Send documents to acknowledgement
              </TheButton>
            </footer>
          </div>
        </>
      )}
      <ConfirmationModal
       isVisible={isModalVisible}
        comment={commentValue || ''}
        people={selectedPersons}
        groups={selectedGroups}
        documents={documents.filter(item => item.checkedAcknowledgementItem)}
        processes={processes.filter(item => item.checkedAcknowledgementItem)}
        deadline={deadline}
        onConfirm={() => onConfirmForm(unitId)}
        onClose={() => setIsModalVisible(false)}></ConfirmationModal>

    </main>
  );
};
